import { render, staticRenderFns } from "./products_numbers.vue?vue&type=template&id=59540a0e&scoped=true"
import script from "./products_numbers.vue?vue&type=script&lang=js"
export * from "./products_numbers.vue?vue&type=script&lang=js"
import style0 from "./products_numbers.vue?vue&type=style&index=0&id=59540a0e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59540a0e",
  null
  
)

export default component.exports